import { Col, Row } from "reactstrap";
import { BackgroundColorTitle } from "../../../Constants/Constants";
import { FontsData } from "../../../Data/Bonus/Elements";

const BackgroundColor = () => {
  return (
    <section className="background">
      <Row>
        <Col xs="12">
          <div className="element-card">
            <div className="element-card-header heading">
              <h2>{BackgroundColorTitle}</h2>
            </div>
            <div className="element-card-body typography">
              {FontsData.map((item, index) => (
                <div className={`bg-${item} p-15`} key={index}>bg-{item}</div>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default BackgroundColor;
